import type { ClientIntakeForm } from '@models/client-intake';

import type { ClientIntakeFormsPathParams } from '../clientIntakeForms.firebase.repo';

export class SetClientIntakeFormsConnection {
	static readonly type = '[ClientIntakeForms] Set Connection';
	constructor(
		public connect: boolean,
		public pathParams: ClientIntakeFormsPathParams,
	) {}
}

export class SetClientIntakeForm {
	static readonly type = '[ClientIntakeForms] Set ClientIntakeForm';
	constructor(public item: ClientIntakeForm | null) {}
}

export class ClearCurrentIntakeFormConnection {
	static readonly type =
		'[ClientIntakeForms] Clear Current Intake Form Connection';
}

export class SetClientIntakeFormIds {
	static readonly type =
		'[ClientIntakeForms] Set Business Id, Matter Id and ClientIntakeForm Id';
	constructor(
		public ids: {
			businessId: string;
			matterId: string;
			clientIntakeFormId: string;
		},
	) {}
}

export class ClearClientIntakeFormIds {
	static readonly type =
		'[ClientIntakeForms] Clear Business Id, Matter Id and ClientIntakeForm Id';
}
